import { apiUrl } from '../constants/apiConsts';
import fetchRequest from '../utils/request';
import { getHeaders } from './helpers';

export default class AnalyticsApi {
  static logEvent (data) {
    let requestBody = {
      event_name: data.event_name,
    };

    if (data.event_action) {
      requestBody.event_params = {
        action: data.event_action,
        debug_mode: 1,
        engagement_time_msec : 144,
      }
    }

    const request = new Request(`${apiUrl}/content/analytics/log_event`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(requestBody),
    });

    return fetchRequest(request);
  }
  static logUserProperty (orgName) {
    const requestBody = {
      org_name: orgName,
    };
    const request = new Request(`${apiUrl}/content/analytics/log_event`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(requestBody),
    });

    return fetchRequest(request);
  }
}
